export default __webpack_public_path__ + "static/media/1976.c9583349.jpg";